import {MoreAboutParticipant} from './common/MoreAboutParticipant';

export class Participant {
  id: number;
  workflowId: number;
  operationId: number;
  personId: number;
  participantType: number;
  orderParticipant: number;
  uploadRubric: boolean;
  typeSignature: number;
  signatureLevel: number;
  createAt: string;
  active: number;
  addTsa: number;
  sendAlert: number;
  sendWspAlert: number;
  sendNotification: number;
  sendCompletionEmail: boolean;
  identityValidation: boolean;
  dragRubric: boolean;
  sendCompletionNotification: boolean;
  documentTracking: boolean;
  documentIntegrity: boolean;
  acceptRubricPlacement: boolean;
  personFullName: string;
  observation: string;
  // tslint:disable-next-line:variable-name
  _more = new MoreAboutParticipant();
}
